import React, { DispatchWithoutAction, FC } from 'react';

import { fc } from 'i18n';
import Button from 'core/react/general/form/Button';
import { InfoTable } from 'components/organisms/tables/info-table';
import { useNotifyLeasesColumns } from 'hooks/tep/leases/useNotifyLeasesColumns';

import styles from '../styles.module.css';

import { useSelector } from 'react-redux';
import { issueModalSelector } from 'core/redux/selectors/tep';

interface IEntryPassesProps {
  count: number;
  onNext: DispatchWithoutAction;
}

export const EntryPasses: FC<IEntryPassesProps> = ({ count, onNext }) => {
  const { leases } = useSelector(issueModalSelector);

  const columns = useNotifyLeasesColumns();

  return (
    <div>
      {/*@ts-ignore*/}
      <InfoTable isLoading={false} height={240} columns={columns} data={leases} />
      <div className={styles.totalCount}>{`Total No. Of Entries : ${count}`}</div>
      <div className={styles.footer}>
        <Button onClick={onNext} className={`${styles.button} active`}>
          <span>{fc('next')}</span>
        </Button>
      </div>
    </div>
  );
};
